module.exports = __webpack_public_path__ + "img/tuceng1.b804a293.png";